/* @ngInject */
export default function PlanImpressionPrixController(
	$scope,
	$state,
	$stateParams,
	PlanImpressionPrixService,
	TemplateImpressionService,
	ModalService,
	$uibModal,
	notification,
	$location,
	$anchorScroll,
	$translate,
	$filter,
	_,
	moment,
	PaginationService,
	MOPService,
	TypesService,
	CaracteristiquesService,
	globalizationManagementService,
	ProductService
) {
	const vm = this;

	let previousTableState;
	vm.lastSelected = undefined;

	vm.slideWidth = '500px';
	vm.slideMargin = {
		'margin-right': '0px',
		'transition-duration': '0.5s',
		'transition-animation': 'margin-right',
		height: '100%'
	};

	vm.itemsByPageOptions = [20, 100, 200];
	vm.itemsByPage = vm.itemsByPageOptions[0];

	vm.$scope = $scope;
	vm.$state = $state;
	vm.$stateParams = $stateParams;
	vm.TypesService = TypesService;
	vm.CaracteristiquesService = CaracteristiquesService;
	vm.PlanImpressionPrixService = PlanImpressionPrixService;
	vm.TemplateImpressionService = TemplateImpressionService;
	vm.ModalService = ModalService;
	vm.$uibModal = $uibModal;
	vm.notification = notification;
	vm.$location = $location;
	vm.$anchorScroll = $anchorScroll;
	vm.$translate = $translate;
	vm.$filter = $filter;
	vm._ = _;
	vm.dateFormat = globalizationManagementService.getCurrentLanguage().dateFormat;
	vm.ProductService = ProductService;

	vm.ongletOpen = {
		isEnteteOpen: true,
		isClientSelectionOpen: true,
		isTypeClientSelectionOpen: true
	};

	vm.societes = [];
	vm.societesSelected = [];
	vm.sites = [];
	vm.sitesSelected;
	vm.clients = [];
	vm.clientsSelected = [];
	vm.chantiers = [];
	vm.selected = false;
	vm.isFilter = false;
	vm.dateDebut = null;
	vm.dateFin = null;
	vm.moment = moment;
	vm.chantiersAvecPrix = false;
	vm.chantierSansPrix = true;
	vm.isEvidencePrix = true;
	vm.hasSelectedTypeClient = false;
	vm.hasSelectedClient = false;
	vm.hasSelectedChantier = false;
	vm.produits = [];
	vm.typeProduits = [];

	vm.getSocietesCommerciales = getSocietesCommerciales;
	vm.getSitesCommerciaux = getSitesCommerciaux;
	vm.getClientSelections = getClientSelections;
	vm.getClients = getClients;
	vm.getTypesClient = getTypesClient;
	vm.getCaracteristiquesProduits = getCaracteristiquesProduits;
	vm.societeChange = societeChange;
	vm.clientsChange = clientsChange;
	vm.anneeChange = anneeChange;
	vm.checkAllClients = checkAllClients;
	vm.checkAllTypesClient = checkAllTypesClient;
	vm.checkAllChantiers = checkAllChantiers;
	vm.print = print;
	vm.download = download;
	vm.annuler = annuler;
	vm.startLoading = startLoading;
	vm.stopLoading = stopLoading;
	vm.openHelper = openHelper;
	vm.exporter = exporter;
	vm.openModalFranco = openModalFranco;
	vm.MOPService = MOPService;
	vm.tarifModeSelectedChange = tarifModeSelectedChange;
	vm.checkTypeClientSelection = checkTypeClientSelection;
	vm.checkClientSelection = checkClientSelection;
	vm.checkChantierSelection = checkChantierSelection;
	vm.loadDomaindata = loadDomainData;
	vm.updateCheckBox = updateCheckBox;
	vm.getProduits = getProduits;
	vm.getTypeProduits = getTypeProduits;

	vm.$onInit = async () => {
		vm.MOPService.setMop([
			{ title: 'PLAN_IMPRESSION_PRIX.BREADCRUMBS.PLAN_IMPRESSION_PRIX', filename: 'PlanImpressionPrix.pdf', application: 'gestion' }
		]);

		vm.tarifModes = [
			{
				id: 0,
				libelle: 'Société commerciale'
			},
			{
				id: 1,
				libelle: 'Site commercial'
			},
			{
				id: 2,
				libelle: 'Type de Client'
			},
			{
				id: 3,
				libelle: 'Client'
			},
			{
				id: 4,
				libelle: 'Chantier'
			}
		];

		await getCaracteristiquesProduits();

		await getSocietesCommerciales();
		await getTypesClient();
		await anneeChange();

		await loadDomainData();
		vm.unregister = [];
		vm.unregister.push(
			vm.$scope.$watch(
				() => vm.dateDebut,
				async () => {
					if (vm.dateDebut && (vm.chantiersAvecPrix || vm.chantierSansPrix)) {
						await clientsChange();
					}
				}
			)
		);
		vm.unregister.push(
			vm.$scope.$watch(
				() => vm.dateFin,
				async () => {
					if (vm.dateFin && (vm.chantiersAvecPrix || vm.chantierSansPrix)) {
						await clientsChange();
					}
				}
			)
		);
	};

	vm.$onDestroy = () => {
		vm.unregister.forEach((unregister) => unregister());
		vm.MOPService.resetMop();
	};

	async function loadDomainData() {
		if (!vm.modalInstance || !vm.currentDomainData) {
			return;
		}

		if (vm.currentDomainData.societeId) {
			const societe = vm.societes.find((s) => s.id === vm.currentDomainData.societeId);
			societe.selected = true;
			vm.societesSelected = [societe];
		} else {
			vm.societes[0].selected = true;
			vm.societesSelected = [vm.societes[0]];
		}

		await societeChange();

		vm.tarifModeSelected = vm.currentDomainData.tarifType;
		vm.tarifModeSelectedChange();
		//si genreclient on selectionne tous les sites commerciaux
		if (vm.currentDomainData.genre !== 'societes') {
			vm.sites = vm.sites.map((s) => {
				s.selected = true;
				return s;
			});
			vm.sitesSelected = vm.sites;
		}

		if (vm.currentDomainData?.genre === 'Chantier') {
			vm.clientSelections = vm.clientSelections.map((e) => {
				if (e.id === vm.currentDomainData.clientchantierId) {
					e.isFilter = true;
					vm.clientsSelected = [e];
				}
				return e;
			});
			await clientsChange();
		}

		vm.updateCheckBox();
	}

	function updateCheckBox() {
		if (vm.currentDomainData?.genre === 'clients') {
			vm.clients = vm.clients.map((e) => {
				if (e.id === vm.currentDomainData.currentItemId) {
					e.selected = true;
					vm.clientsSelected = [e];
					vm.hasSelectedClient = true;
				}
				return e;
			});
		}

		if (vm.currentDomainData?.genre === 'Type de Client') {
			vm.typesClient = vm.typesClient?.map((e) => {
				if (e.id === vm.currentDomainData.currentItemId) {
					e.selected = true;
					vm.hasSelectedTypeClient = true;
				}
				return e;
			});
		}
		if (vm.currentDomainData?.genre === 'Chantier') {
			vm.chantiers = vm.chantiers.map((e) => {
				if (e.id === vm.currentDomainData.currentItemId) {
					e.selected = true;
					vm.hasSelectedChantier = true;
				}
				return e;
			});
		}
	}

	async function getSocietesCommerciales() {
		startLoading();
		try {
			vm.societes = await vm.PlanImpressionPrixService.getSocietesCommerciales();
			if (vm.societes.length == 1) {
				vm.societes[0].selected = true;
				vm.societesSelected.push(vm.societes[0]);
				await societeChange();
			}
		} catch (ex) {
			vm.notification.error(ex.data);
		} finally {
			stopLoading();
		}
	}

	async function getSitesCommerciaux(idSociete) {
		startLoading();
		try {
			vm.sites = await vm.PlanImpressionPrixService.getSitesCommerciaux(idSociete);
		} catch (ex) {
			vm.notification.error(ex.data);
		} finally {
			stopLoading();
		}
	}

	async function getClientSelections(idSociete) {
		startLoading();
		try {
			vm.clientSelections = await vm.PlanImpressionPrixService.getClientSelections(idSociete);
		} catch (ex) {
			vm.notification.error(ex.data);
		} finally {
			stopLoading();
		}
	}

	async function getClients(tableState) {
		startLoading();

		if (tableState) {
			previousTableState = tableState;
		}

		const filters = PaginationService.getFilters(previousTableState);
		const sorts = PaginationService.getSorts(previousTableState);
		const pagination = PaginationService.getPagination(previousTableState);

		try {
			const idSociete = vm.societesSelected[0] ? vm.societesSelected[0].id : 0;
			const data = await vm.PlanImpressionPrixService.getClients(filters, sorts, pagination, idSociete);
			vm.clients = data.items;
			updateCheckBox();

			if (previousTableState) {
				PaginationService.setTableState(data.skip, data.take, data.total, previousTableState);
			}
		} catch (ex) {
			vm.notification.error(ex.data);
		} finally {
			stopLoading();
		}
	}

	async function getCaracteristiquesProduits() {
		startLoading();
		try {
			const data = await vm.CaracteristiquesService.getCaracteristiques();
			vm.caracteristiquesProduits = data.items.filter(
				(carac) => carac.domainesCodes.some((code) => code == 'Produits') && carac.nature.idNature == 5
			);
		} catch (error) {
			console.log(error);
		} finally {
			stopLoading();
		}
	}

	async function getTypesClient() {
		startLoading();
		try {
			const data = await vm.TypesService.getTypes(
				[{ criterion: 'domaine', value: 'Sites clients', type: 'Contains' }],
				[],
				{ skip: 0, take: 0 },
				'gestion'
			);
			vm.typesClient = data.items;
		} catch (error) {
			console.log(error);
		} finally {
			stopLoading();
		}
	}

	async function societeChange() {
		if (!vm.societesSelected.length) {
			return;
		}
		vm.tarifModeSelected = 0;
		await getSitesCommerciaux(vm.societesSelected[0].id);
		await getClientSelections(vm.societesSelected[0].id);
		await getClients();
		await getProduits();
		await getTypeProduits();

		vm.sites.forEach((site) => {
			site.selected = true;
		}, vm);
	}

	function tarifModeSelectedChange() {
		if (!vm.societesSelected?.length) {
			return;
		}

		if (vm.tarifModeSelected == 0) {
			// pour le type Société commerciale on vide les sites
			vm.sitesSelected = [];
		}

		if (vm.chantiers?.some((e) => e.selected)) {
			vm.chantiers = vm.chantiers.map((e) => {
				e.selected = false;
				return e;
			});
			checkChantierSelection();
		}

		if (this.tarifModeSelected == 3) {
			//lors de la selection du type tarif Client
			vm.clientsSelected = [];
		}

		if (vm.typesClient?.some((e) => e.selected)) {
			vm.typesClient = vm.typesClient.map((e) => {
				e.selected = false;
				return e;
			});
			checkTypeClientSelection();
		}

		if (vm.clients?.some((e) => e.selected)) {
			vm.clients = vm.clients.map((e) => {
				e.selected = false;
				return e;
			});
			checkClientSelection();
		}
	}

	function checkTypeClientSelection() {
		vm.hasSelectedTypeClient = vm.typesClient.some((type) => type.selected);
	}

	function checkClientSelection() {
		vm.hasSelectedClient = vm.clients.some((client) => client.selected);
	}

	function checkChantierSelection() {
		vm.hasSelectedChantier = vm.chantiers.some((chantier) => chantier.selected);
	}

	async function clientsChange(opt) {
		startLoading();
		try {
			vm.chantiers = null;
			const displayChantiers = [];

			if (opt == 'chantiersAvecPrix' && vm.chantierSansPrix) {
				vm.chantierSansPrix = false;
			}
			if (opt == 'chantierSansPrix' && vm.chantiersAvecPrix) {
				vm.chantiersAvecPrix = false;
			}

			vm.clients.forEach((client) => {
				client.selected = false;
			});

			if (vm.clientsSelected.length < 1) {
				//
			} else {
				for (let i = 0; i < vm.clientsSelected.length; i++) {
					const client = vm.clientsSelected[i];

					let chantiers = [];
					if (vm.chantiersAvecPrix) {
						const societeId = vm.societesSelected[0].id;
						const siteIds = vm.sitesSelected.length > 0 ? vm.sitesSelected.map((e) => e.id) : [0];
						chantiers = await PlanImpressionPrixService.getChantierPrixByClients(
							client.id,
							societeId,
							siteIds,
							vm.dateDebut.replace(/\//g, '-'),
							vm.dateFin.replace(/\//g, '-'),
							1
						);
					} else if (vm.chantierSansPrix) {
						const societeId = vm.societesSelected[0].id;
						const siteIds = vm.sitesSelected.length > 0 ? vm.sitesSelected.map((e) => e.id) : [0];
						const chantiersAvecPrix = await PlanImpressionPrixService.getChantierPrixByClients(
							client.id,
							societeId,
							siteIds,
							vm.dateDebut.replace(/\//g, '-'),
							vm.dateFin.replace(/\//g, '-'),
							1
						);
						const allchantiers = await PlanImpressionPrixService.getChantierByClients(client.id);

						allchantiers.forEach((chantier) => {
							const isFound = chantiersAvecPrix.find((e) => e.id === chantier.id);
							if (!isFound) {
								chantiers.push(chantier);
							}
						});
					} else {
						chantiers = await vm.PlanImpressionPrixService.getChantierByClients(client.id);
					}

					chantiers.forEach((chantier) => {
						const isFound = displayChantiers.find((e) => e.id === chantier.id);
						if (!isFound) {
							chantier.clientLibelle = client.libelle;
							chantier.idTypeclient = client.idTypeclient;
							displayChantiers.push(chantier);
						}
					});
				}
			}

			vm.chantiers = angular.copy(displayChantiers);
			updateCheckBox();
		} catch (ex) {
			vm.notification.error(ex.data);
		} finally {
			stopLoading();
		}
	}

	async function anneeChange() {
		vm.dateDebut = vm.moment().startOf('year').format(vm.dateFormat);
		vm.dateFin = vm.moment().endOf('year').format(vm.dateFormat);

		if (vm.chantiersAvecPrix || vm.chantierSansPrix) {
			await clientsChange();
		}
	}

	async function checkAllClients() {
		vm.clients.map(function (e) {
			e.selected = !vm.selected;
		}, vm);
		checkClientSelection();
	}

	async function checkAllTypesClient() {
		vm.typesClient.map(function (e) {
			e.selected = !vm.typeSelected;
		}, vm);
		checkTypeClientSelection();
	}

	async function checkAllChantiers() {
		vm.chantiers.map(function (e) {
			e.selected = !vm.selected;
		}, vm);
		checkChantierSelection();
	}

	async function getPrintOptions() {
		const dateNow = new Date();
		const print = {
			societeId: null,
			sitesId: [],
			clientsId: [],
			chantiersId: [],
			typesClientIds: [],
			annee: dateNow.getFullYear(),
			dateDebut: vm.dateDebut,
			dateFin: vm.dateFin,
			pdf: false,
			domaine: vm.domaine,
			templateId: null,
			isTarifParPage: vm.isTarifParPage,
			isRegroupementProduit: vm.isRegroupementProduit,
			withTypeProduit: vm.withTypeProduit,
			idRuptureCaracteristique: vm.caracteristiqueSelected,
			isPrestation: vm.isPrestation,
			isEvidencePrix: vm.isEvidencePrix
		};
		const idTypeClients = [];
		let type = 'client';
		let idSelected = 0;

		let dataReady = true;

		if (vm.societesSelected == null || vm.societesSelected.length < 1) {
			dataReady = false;
		} else {
			print.societeId = vm.societesSelected[0].id;
		}

		vm.sitesSelected.forEach((site) => {
			if (site.selected) {
				print.sitesId.push(site.id);
			}
		});

		if (vm.tarifModeSelected == 2) {
			vm.typesClient.forEach((type) => {
				if (type.selected) {
					print.typesClientIds.push(type.id);
				}
			}, vm);
		}

		if (vm.tarifModeSelected != 0) {
			if (print.sitesId.length > 0) {
				vm.clients.forEach((client) => {
					if (client.selected) {
						if (!idTypeClients.includes(client.idTypeclient)) {
							idTypeClients.push(client.idTypeclient);
						}
						print.clientsId.push(client.id);
					}
				}, vm);

				vm.chantiers.forEach((chantier) => {
					if (chantier.selected) {
						if (!idTypeClients.includes(chantier.idTypeclient)) {
							idTypeClients.push(chantier.idTypeclient);
						}
						print.chantiersId.push(chantier.id);
					}
				}, vm);

				if (print.clientsId.length < 1) {
					type = 'siteCommercial';
				}

				if (print.clientsId.length == 1) {
					type = 'client';
					idSelected = print.clientsId[0];
				} else {
					if (idTypeClients.length == 1) {
						type = 'typeClient';
						idSelected = idTypeClients[0];
					} else {
						type = 'aucun';
					}
				}

				if (print.chantiersId.length == 1) {
					type = 'chantier';
					idSelected = print.chantiersId[0];
				} else {
					if (idTypeClients.length == 1) {
						type = 'typeClient';
						idSelected = idTypeClients[0];
					} else {
						type = 'aucun';
					}
				}
			} else {
				//Aucun site commercial n'a été sélectionné pour traitement
				vm.notification.error("Aucun site commercial n'a été sélectionné pour traitement");
				dataReady = false;
			}
		}
		return {
			print: print,
			type: type,
			idSelected: idSelected,
			dataReady: dataReady
		};
	}

	async function openModalFranco() {
		const that = vm;
		const printOptions = await getPrintOptions();
		const print = printOptions.print;
		const type = printOptions.type;
		const idSelected = printOptions.idSelected;
		const dataReady = printOptions.dataReady;
		if (dataReady) {
			if (!vm.isFranco) {
				vm.$uibModal
					.open({
						template:
							'<plan-impression-prix-franco modal-instance="$ctrl.uibModalInstance" date="$ctrl.date" domaine="$ctrl.type" url-domain-ids="$ctrl.urlDomainIds" url-domain-name="$ctrl.urlDomainName" id="$ctrl.idSelected"></plan-impression-prix-franco>',
						controller: [
							'$uibModalInstance',
							function ($uibModalInstance) {
								const $ctrl = this;
								$ctrl.uibModalInstance = $uibModalInstance;
								$ctrl.type = type;
								$ctrl.date = that.dateDebut;
								$ctrl.idSelected = idSelected;
								$ctrl.urlDomainIds = print.sitesId.length > 0 ? print.sitesId : [print.societeId];
								$ctrl.urlDomainName = print.sitesId.length > 0 ? 'siteCommercial' : 'societe';
							}
						],
						controllerAs: '$ctrl',
						size: 'xxl',
						backdrop: false
					})
					.result.then(
						async function (result) {
							if (result) {
								vm.prixTransport = result.prix;
								vm.libelleTransport = result.transportLibelle + ' - ' + result.benneLibelle + ' : ' + result.prix + ' €';
							} else {
								vm.isFranco = false;
							}
						},
						function () {
							// console.info("I was dimissed, so do what I need to do myContent's controller now.  Reason was->" + reason);
						}
					);
			} else {
				vm.prixTransport = null;
				vm.libelleTransport = '';
			}
		}
	}

	async function print() {
		const printOptions = await getPrintOptions();
		const print = printOptions.print;
		const dataReady = printOptions.dataReady;
		if (!dataReady) {
			//Données pour traitement incomplete, merci de bien vouloir contrôler votre saisie.
			vm.notification.error('Données incomplete pour traitement, merci de bien vouloir contrôler votre saisie.');
			return;
		}
		startLoading();
		try {
			const templates = await TemplateImpressionService.getTemplateByDomaine(vm.domaine);
			let templateSelected = null;

			if (templates && templates.length > 0) {
				if (vm.isFranco && vm.prixTransport) {
					print.prixTransport = vm.prixTransport;
				}
				templateSelected = await TemplateImpressionService.downloadModal(vm.domaine);
				print.templateId = templateSelected.id;
				print.pdf = templateSelected.pdf;

				if (print.templateId !== undefined) {
					const response = await PlanImpressionPrixService.generate(print);
					download(response);
				}
			}
		} catch (e) {
			//console.log(e);
		} finally {
			stopLoading();
		}
	}

	function download(response, fileName) {
		if (response) {
			const data = response.data;
			let headers = response.headers;
			headers = headers();

			const contentType = headers['content-type'];

			const linkElement = document.createElement('a');
			try {
				const blob = new Blob([data], { type: 'application/octet-stream' + ';charset=UTF-8' });
				const url = window.URL.createObjectURL(blob);
				linkElement.setAttribute('href', url);

				if (!fileName) {
					fileName = 'PlanPrix_' + Date.now();
				}

				if (contentType === 'application/pdf') {
					linkElement.setAttribute('download', fileName + '.pdf');
				} else if (contentType === 'application/octet-stream') {
					linkElement.setAttribute('download', fileName + '.docx');
				} else if (contentType === 'text/csv') {
					linkElement.setAttribute('download', fileName + '.csv');
				} else {
					linkElement.setAttribute('download', fileName + '.zip');
				}

				const clickEvent = new MouseEvent('click', {
					view: window,
					bubbles: true,
					cancelable: false
				});
				linkElement.dispatchEvent(clickEvent);
			} catch (ex) {
				//console.log(e);
			}
		}
	}

	function annuler() {
		if (vm.modalInstance) {
			vm.modalInstance.dismiss();
		} else {
			vm.$state.go('gestion.home');
		}
	}

	function startLoading() {
		vm.loading = true;
	}

	function stopLoading() {
		vm.loading = false;
	}

	function openHelper() {
		vm.$uibModal.open({
			animation: true,
			size: 'lg',
			component: 'planImpressionPrixHelper'
		});
	}

	async function exporter() {
		const data = {
			societeId: null,
			sitesId: [],
			clientsId: [],
			chantiersId: [],
			typesClientIds: [],
			dateDebut: vm.dateDebut,
			isPrestation: vm.isPrestation,
			prixTransport: vm.prixTransport,
			withTypeProduit: vm.withTypeProduit,
			idRuptureCaracteristique: vm.caracteristiqueSelected,
			produitExluIds: vm.selectedProduit.map((e) => e.produitId),
			typeProduitExluIds: vm.selectedTypeProduit.map((e) => e.id)
		};

		if (vm.societesSelected && vm.societesSelected.length >= 1) {
			data.societeId = vm.societesSelected[0].id;
		}
		vm.sitesSelected.forEach((site) => {
			if (site.selected) {
				data.sitesId.push(site.id);
			}
		});

		data.clientsId = vm.clientsSelected.map((e) => e.id);
		vm.clients.forEach((client) => {
			if (client.selected) {
				data.clientsId.push(client.id);
			}
		}, vm);

		vm.chantiers.forEach((chantier) => {
			if (chantier.selected) {
				data.chantiersId.push(chantier.id);
			}
		}, vm);

		if (vm.tarifModeSelected == 2) {
			vm.typesClient.forEach((type) => {
				if (type.selected) {
					data.typesClientIds.push(type.id);
				}
			}, vm);
		}

		try {
			startLoading();
			const response = await PlanImpressionPrixService.exporter(data);
			vm.download(response, 'ExportPrix_' + Date.now());
		} catch (e) {
			vm.notification.error(e.data);
		} finally {
			stopLoading();
		}
	}

	/**
	 * Récupère les produits liés (en entrées et sorties)
	 * à travers le centre de paramétrage de la société
	 */
	async function getProduits() {
		startLoading();
		try {
			const dataEntree = await PlanImpressionPrixService.getProduitsLies({
				societeId: vm.societesSelected[0].id,
				date: vm.moment().format(vm.dateFormat),
				hasToCheckPont: false,
				entreeSortie: 1
			});
			const dataSortie = await PlanImpressionPrixService.getProduitsLies({
				societeId: vm.societesSelected[0].id,
				date: vm.moment().format(vm.dateFormat),
				hasToCheckPont: false,
				entreeSortie: 0
			});
			const produits = [...dataEntree, ...dataSortie];
			vm.produits = [...new Map(produits.map((item) => [item.produitId, item])).values()];
		} catch (e) {
			console.error(e);
		} finally {
			stopLoading();
		}
	}

	async function getTypeProduits() {
		const data = await vm.TypesService.getTypes(
			[{ criterion: 'domaine', value: 'Produits', type: 'Contains' }],
			[],
			{ skip: 0, take: 0 },
			'gestion'
		);
		vm.typeProduits = data.items;
	}
}
